import { PhotoProgress } from 'src/onboarding/components/ui/photo-progress';
import '../../pages/lts-photo-example/style.scss';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { t } from '@web-solutions/module-localization';
import exclamation from '../../assets/images/exclamation.png';
import Button from 'src/onboarding/components/ui/button/Button';

const ScanOverlay = ({
  imageUrl,
  base64Image,
  isBlurred,
  hideScanLine,
  isImageLoaded,
  showErrorPopUp,
  errorTitle,
  errorDescription,
  isBodyScan,
  onImageLoad,
  onChoosePhoto,
  onSkip,
}: {
  imageUrl?: string;
  base64Image?: string;
  isBlurred?: boolean;
  hideScanLine: boolean;
  isImageLoaded: boolean;
  showErrorPopUp: boolean;
  errorTitle: string;
  errorDescription: string;
  isBodyScan?: boolean;
  onImageLoad: () => void;
  onChoosePhoto: () => void;
  onSkip: () => void;
}) => {
  return (
    <div className='face-scan-overlay'>
      <img
        onLoad={onImageLoad}
        src={imageUrl || base64Image}
        alt='user-upload'
        className={isBlurred ? 'blurred' : ''}
      />

      {!hideScanLine && isImageLoaded && <div className='scan-line' />}

      {isBlurred && !showErrorPopUp && !isBodyScan && (
        <>
          <PhotoProgress />
          <div className='scan-description'>
            <Title tag='h3'>{t('onboarding.lts-photo-example.faceScan.title')}</Title>
            <Text size='m' medium>
              {t('onboarding.lts-photo-example.faceScan.subTitle')}
            </Text>
          </div>
        </>
      )}

      {/* {showErrorPopUp && (
      <>
        <div className='error-popup'>
          <div className='popup-title'>
            <img className='exclamation' src={exclamation} alt='exclamation'/>

            <Text semibold>{errorTitle}</Text>
          </div>
          <Text regular size='m' className='error-text'>
            {errorDescription}
          </Text>
          <div className='popup-controls'>
            <Button
              title={t('onboarding.lts-photo-example.faceScan.choosePhoto')}
              onClick={onChoosePhoto}
            />
            <Button
              title={t('onboarding.lts-photo-example.faceScan.skip')}
              type={'secondary'}
              className='later-button'
              onClick={onSkip}
            />
          </div>
        </div>
      </>
    )} */}
    </div>
  );
};

export default ScanOverlay;